import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { AddToCartConfirmationDTO, Item, ItemMinimalDetails } from 'src/app/shared-core/models/cart-data.model';
import { CartService } from 'src/app/shared-core/services/cart.service';
import { ProductService } from 'src/app/shared-core/services/product.service';

@Component({
    selector: 'app-product-recommendations',
    templateUrl: './product-recommendations.component.html',
    styleUrls: ['./product-recommendations.component.scss']
})
export class ProductRecommendationsComponent implements AfterViewInit {
    // Frequently Bought Together Inputs, Related Items Inputs
    @Input() public webCode: string;

    // Frequently Bought Together Inputs
    @Input() public parentItem: ItemMinimalDetails;

    // Trending Items Inputs
    @Input() public facetName: string;
    @Input() public facetValue: string;

    // Shared Inputs
    @Input() public recommendationType: string;

    public addToCartConfirmationDto: AddToCartConfirmationDTO = null;
    public isReady = false;
    public recommendations: ItemMinimalDetails[] = [];
    public isXSmall = true; // hide by default

    get shouldHide() {
        return !this.isReady
    }

    constructor(
        private _productService: ProductService,
        private _cartService: CartService,
        private _changeDetectorRef: ChangeDetectorRef
    ) {}

    public ngAfterViewInit(): void {
        let observable: Observable<ItemMinimalDetails[]>;

        switch (this.recommendationType) {
            case 'related':
                observable = this._productService.getRelatedProducts(this.webCode);
                break;
            case 'frequentlyBoughtTogether':
                observable = observable = this._productService.getFrequentlyBoughtTogetherProducts(this.webCode, true);
                break;
            case 'trending':
                observable = this._productService.getTrendingProducts(this.facetName, this.facetValue);
                break;
            default:
                observable = null;
                break;
        }

        if (!observable) {
            return;
        }

        this.recommendationsSubscribe(observable);
    }

    private recommendationsSubscribe(observable: Observable<ItemMinimalDetails[]>) {
        observable.subscribe((result) => {
            this.recommendations = result;
            this.isReady = true;
            this._changeDetectorRef.detectChanges();
        });
    }

    public hideAddedToCartConfirmation() {
        this.addToCartConfirmationDto = null;
    }

    public addedToCart($event: Item) {
        const item = $event;

        this._cartService
            .getAddToCartConfirmationDTO(item.Webcode, item.InventorySourceType)
            .subscribe((addToCartConfirmationDto: AddToCartConfirmationDTO) => {
                this.addToCartConfirmationDto = addToCartConfirmationDto;
            });
    }
}
